import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthState, Tokens } from "@trtl/portal/auth";
import { ENV } from "@trtl/portal/env";
import { catchError, tap, throwError } from "rxjs";
import { Admin, UserState } from "./user";

@Injectable({ providedIn: 'root' })
export class AdminApi {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENV);

  public getProfile() {
    return this.http.get<Admin>(`${this.env.api.admin}/profile`)
      .pipe(
        tap(user => UserState.patchUser(user)),
      );
  }

  public refreshToken(refreshToken: string) {
    return this.http.post<Tokens>(`${this.env.api.admin}/auth/refresh`, { refreshToken })
      .pipe(
        tap(tokens => AuthState.setTokens(tokens)),
        catchError((err) => {
          AuthState.setTokens();

          return throwError(() => err);
        }),
      );
  }
}
